module.exports = __webpack_public_path__ + "img/exercise_test-4.42832b14.png";